import { TableColumn } from "../../types";
import { DateString } from "../../../../components/dateString";
import { formatStrings } from "../../../../utils/time";
import { useAppSelector } from "../../../../store/hooks";
import { selectLabel } from "../../../../store/timezoneSlice";

interface DateStringColumnOptions {
  label?: string;
  format?: string;
}
export function DateStringColumn<TData>(
  column: Partial<TableColumn<TData>>,
  options: DateStringColumnOptions = {},
) {
  const timezoneLabel = useAppSelector(selectLabel);
  const label = options.label ?? "Timestamp";
  const format = options.format ?? formatStrings.date;

  const preset: Partial<TableColumn<TData>> = {
    label: `${label} (${timezoneLabel})`,
    size: 230,
    maxSize: 230,
    cell: ({ getValue }) => <DateString iso={getValue()} format={format} />,
  };
  return Object.assign(preset, column) as TableColumn<TData>;
}
